import React from 'react';
import { useCompanyContext } from '../../../../contexts/Company';
import { PercentageInputTextField } from '../../../BuildingBlocks/Form/PercentageTextField';
import makeStyles from '@material-ui/core/styles/makeStyles';
import RadioGroup from '../../../BuildingBlocks/Form/RadioGroup';
import Header from '../../../BuildingBlocks/Headers/BoldHeader';
import TextField from '../../../BuildingBlocks/Form/TextField';

const useStyles = makeStyles((theme: any) => ({
  ownership: {
    display: 'block',
    position: 'relative',
    marginBottom: theme.spacing(4.5),
    paddingLeft: theme.spacing(2.75),
  },
  header: {
    marginTop: 0,
    marginBottom: theme.spacing(3),
  },
  radioGroup: {
    marginBottom: theme.spacing(3.5),
  },
  noMarginBottom: {
    marginBottom: 0,
  },
  greyBorder: {
    width: theme.spacing(0.75),
    position: 'absolute',
    borderRadius: '2px',
    background: theme.palette.brand.greyWhite,
    marginLeft: theme.spacing(-2.75),
    height: '100%',
  },
}));

export default function CompanyMajorityQuestions({
  setValue,
  useWatch,
  control,
  register,
  errors,
}) {
  const classes = useStyles();
  const { business } = useCompanyContext();
  const companyName = business.name || 'your company';

  const questions = [
    {
      id: 'yes',
      text: (
        <span>
          <b>
            <u>I do</u>
          </b>{' '}
          own a majority of the shares in {companyName}.
        </span>
      ),
    },
    {
      id: 'no',
      text: (
        <span>
          <b>
            <u>I do not</u>
          </b>{' '}
          own a majority of the shares in {companyName}.
        </span>
      ),
    },
  ];

  const companyMajority = useWatch({ control, name: 'companyMajority' });

  return (
    <>
      <div className={classes.radioGroup}>
        <RadioGroup
          groupId="companyMajority"
          options={questions}
          setValue={setValue}
          useWatch={useWatch}
          control={control}
        />
      </div>
      {companyMajority === 'no' && (
        <div className={classes.ownership}>
          <div className={classes.greyBorder} />
          <div>
            <Header className={classes.header}>
              Please list the name of the person or entity that owns the
              majority of the shares {companyName}.
            </Header>
            <TextField
              errors={errors}
              label={'Name of Person/Entity'}
              name={'ownerName'}
              TextFieldProps={{
                ...register('ownerName', {
                  required: {
                    value: true,
                    message: 'This field is required.',
                  },
                }),
              }}
            />
            <PercentageInputTextField
              errors={errors}
              label={'Percent Ownership'}
              name={'ownerPercentage'}
              className={`${classes.noMarginBottom}`}
              TextFieldProps={{
                ...register('ownerPercentage', {
                  required: {
                    value: true,
                    message: 'This field is required.',
                  },
                }),
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
